import React from 'react';

type LoadingIconProps = {
  size?: string;
  className?: string;
};

const AiLoadingIcon: React.FC<LoadingIconProps> = ({
  size = '24px',
  className,
}) => {
  const radius = 8.4;
  const strokeWidth = 1.9;
  const circumference = 2 * Math.PI * radius;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      {/* 회색 배경 원 */}
      <circle
        cx="12"
        cy="12"
        r={radius}
        stroke="#D4D7DB"
        strokeWidth={strokeWidth}
        fill="none"
      />

      {/* 회전하는 보라색 경로 */}
      <circle
        cx="12"
        cy="12"
        r={radius}
        stroke={'#C77AC4'}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
        strokeDasharray={circumference * 0.75}
        strokeDashoffset={circumference * 0.25}
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 12 12"
          to="360 12 12"
          dur="800ms"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};

export default AiLoadingIcon;
